import { Injectable } from '@angular/core';
import { createApi } from 'unsplash-js';
import { ConfigurationService } from '../../configuration.service';

export interface IUnsplashQuery {
    query: string;
    page: number;
    perPage?: number;
}

@Injectable()
export class UnsplashApiManagerService {
    private unsplashApi = createApi({
        apiUrl: this.configurationService.apiIP + '/unsplash',
    });

    constructor(private configurationService: ConfigurationService) {}

    searchPhotosAsync(data: IUnsplashQuery) {
        if (!data) {
            return;
        }
        return this.unsplashApi.search.getPhotos({ query: data.query, page: data.page, perPage: data.perPage ?? 10 });
    }
}
